import React, { FunctionComponent, useEffect } from 'react';

import { CommonError } from 'src/components/common-error/common-error';
import { monkeyImageProps } from 'src/resources/images';
import { resetStateActionCreator } from 'src/state/common/reset-state-action-creator';
import { useAppDispatch } from 'src/state/thunk-api';
import { i18n } from 'src/i18n';

export const PageError: FunctionComponent = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetStateActionCreator());
  }, [dispatch]);

  return (
    <CommonError
      title={i18n.page.error.generic.title}
      subtitle={i18n.page.error.generic.description}
      image={monkeyImageProps}
    />
  );
};
